import React, { FunctionComponent } from "react"
import { Button, Grid } from "@material-ui/core"
import { useStepControlsContext } from "./useStepControlsContext"

export const StepControls: FunctionComponent = () => {
    const { state, navigateNext, navigateBack } = useStepControlsContext()
    return (
        <Grid container spacing={1} direction={"row"} alignItems={"center"}>
            {state.back.visible && (
                <Grid item>
                    <Button
                        id={"back-btn"}
                        data-testid={"step-back-btn"}
                        disabled={!state.back.active}
                        onClick={navigateBack}
                    >
                        Back
                    </Button>
                </Grid>
            )}
            {state.next.visible && (
                <Grid item>
                    <Button
                        id={"next-btn"}
                        data-testid={"step-next-btn"}
                        disabled={!state.next.active}
                        onClick={navigateNext}
                        variant={"contained"}
                        color={"primary"}
                    >
                        Next
                    </Button>
                </Grid>
            )}
        </Grid>
    )
}
